import React, { useMemo } from 'react';
import { Operation } from './Operation';
import { sortMembersBySortOrderFirst } from '../../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';

interface OperationsListProps {
  node: any;
  prefix: string;
}

export function OperationsList({ node, prefix }: OperationsListProps) {
  const sortedNodeOperations = useMemo(() => {
    return sortMembersBySortOrderFirst(node?.data?.operations || []) || [];
  }, [node]);

  return (
    <>
      {sortedNodeOperations.map((operation, i) => (
        <Operation
          prefix={prefix}
          key={`OPERATION__${operation.urlFormat}__${node.data.urlFormat}_${i}`}
          node={node}
          operation={operation}
        />
      ))}
    </>
  );
}
